/**
 * Application methods
 */
import register from "./register";

/**
 * Plugin server methods
 */

export default {
  register,
};
